export default "__VITE_ASSET__C3Q$Hdgn__";